// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Speedbag_wrap__1teJ7","nav":"Speedbag_nav__3IrlN","primary":"Speedbag_primary__4PlzN","secondary":"Speedbag_secondary__-A__E"};